import type {
  Data, Variables, Cache, UpdatesConfig,
} from '@urql/exchange-graphcache';

import invalidateQuery from './util/invalidateQuery';

const agencyHoursExchange: UpdatesConfig['Mutation'] = {
  agencyHoursCreate: (_: Data, __: Variables, cache: Cache) => invalidateQuery(
    ['agencyHoursByDate', 'agencyHours'],
    cache,
  ),
  agencyHoursDelete: (_: Data, __: Variables, cache: Cache) => invalidateQuery(
    ['agencyHoursByDate', 'agencyHours'],
    cache,
  ),
};

export default agencyHoursExchange;
